/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-18 14:09:11
 * @LastEditTime: 2022-08-15 14:55:22
 * @FilePath: /insurforce-backstage-platform-side/src/views/claim/recordManage/utils.js
 */
const columns = [{
  slots: {
    title: '标签'
  },
  dataIndex: 'tag',
  key: '0',
  align: 'center',
  scopedSlots: {
    customRender: 'tag'
  },
  width: 80
}, {
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: 'policyNo',
  align: 'center'
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'insuranceName',
  key: 'insuranceName',
  align: 'center'
}, {
  slots: {
    title: '保单归属'
  },
  dataIndex: 'customerName',
  key: 'customerName',
  align: 'center'
}, {
  slots: {
    title: '出单组织'
  },
  dataIndex: 'structureName',
  key: 'structureName',
  align: 'center'
}, {
  slots: {
    title: '申请人'
  },
  dataIndex: 'userName',
  key: 'userName',
  align: 'center'
}, {
  slots: {
    title: '申请时间'
  },
  dataIndex: 'createAt',
  key: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '审核状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  customRender: text => {
    if (text === 'PENDING') {
      return window.vm.$i18n.t('待审核');
    } else if (text === 'PASSED') {
      return window.vm.$i18n.t('审核通过');
    }
    return window.vm.$i18n.t('审核未通过');
  }
},
// {
//   title: '结案状态',
//   dataIndex: 'isClose',
//   key: 'isClose',
//   align: 'center',
//   customRender: text => {
//     return text === 0 ? '未结案' : '已结案';
//   }
// },
{
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
export { columns, pagination };